import { appVersionInfo } from './version-info.local';

export const environment = {
  production: true,
  versionInfo: appVersionInfo,
};
